<template>
  <select v-model="$i18n.locale" class="d-none">
    <option v-for="(locale, i) in locales" :key="`locale-${i}`" :value="locale">
      {{ locale }}
    </option>
  </select>
</template>

<script>
export default {
  name: "LocaleSwitcher",
  data() {
    return {locales: ["be", "be_nl", "be_nl_vf", "de", "de_at", "de_co", "de_st", "de_vf", "en", "se"]};
  },
};

/**
 https://cancellation.tink.de/ => DE
 https://cancellation-vattenfall.tink.de/ => DE
 https://cancellation-cosmos.tink.de/ => DE
 https://cancellation.tink.at/ => DE
 https://cancellation-smartthings.tink.de/ => DE

 https://cancellation.tink.nl/ => NL
 https://cancellation-vattenfall.tink.nl/ => NL
 https://cancellation.tink.be/ => NL

 https://cancellation.tink.net/ => SE
 **/
</script>
